import { Component } from '@angular/core';
import { NavController, NavParams, Events, ViewController, PopoverController} from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { trigger, transition, useAnimation, state, style } from '@angular/animations';
import { tada } from 'ng-animate';
import { MonedaPage } from '../moneda/moneda';
/**
 * Generated class for the DetallePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-detalle',
  templateUrl: 'detalle.html',
  animations:[
    trigger('car',[
      state('open',style({
        backgroundColor:'transparent' 
      })),
      state('close',style({
        backgroundColor:'transparent' 
      })),
      transition('open=>close',useAnimation(tada,{
        params:{
          timing:2
        }
      })),
      transition('close=>open',useAnimation(tada,{
        params:{
          timing:2
        }
      }))
    ])
  ]
})
export class DetallePage {
  pedido:any = {}
  codigo: any = ''
  path:string=this.https.images
  moneda: any = 'USD'
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public popCtrl: PopoverController,
    public https: HttpProvider,
    public events : Events,
    public viewCtrl : ViewController,
    ) {
      events.subscribe('moneda:update', ()=>{
        this.updateMoneda()
      })
      if(window.localStorage.moneda){
        this.moneda = window.localStorage.moneda
      }
      this.codigo = this.navParams.get('pedido')
      if(window.localStorage.getItem('network') === '1'){
        this.https.get(`pedidosCom/cod/${this.codigo}`).subscribe(
          (res:any=[])=>{
            if(res.length){
              this.pedido = {
                ...res[0],
              }
            }
          },
          error=>console.log(error)
        )
      }
  }

  updateMoneda(){
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
  }

  showMonedas(){
    const pop = this.popCtrl.create(MonedaPage, {}, {cssClass: 'popppover'})
    pop.present()
  }

  buscarMetodo(item) {
    let cond = JSON.parse(window.localStorage.getItem('condiciones'))
    let result = ''
    if (cond && cond.length > 0) {
      cond.forEach(el=>{
        if (item.trim() === el.co_cond.trim()) {
          result = el.cond_des.trim()
        }
      })
    }
    return result
  }

  transform(value) {
    if(value){
      let val
      val = parseFloat(value)
      val = parseFloat(val).toFixed(2)
      val = val.toString().split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }

  printEstatus(status){
    if(status){
      status = status.replace(' ','')
      switch(status){
        case '0':return 'Creado'
        case '1':return 'Parcial'
        case '2':return 'Procesado'
      }
    }
  }

  close(){
    this.viewCtrl.dismiss()
  }

}



// WEBPACK FOOTER //
// ./src/pages/detalle/detalle.ts